import { useQuery } from "@tanstack/react-query";
import { verifyKeys } from "./keys.ts";
import { getStagesToVerify } from "../requests/get-stages-to-verify.ts";
import type {
  StagesToVerifyListResponse,
  VerifyQueryParams,
} from "../../types.ts";
import { reactQueryCacheAndRefetchOptions } from "@";

// Query hook for fetching verification stages to verify
export const useStagesToVerifyQuery = (params: VerifyQueryParams | null) => {
  return useQuery<StagesToVerifyListResponse>({
    queryKey: verifyKeys.stagesToVerify(params as VerifyQueryParams),
    queryFn: async () => {
      const { data } = await getStagesToVerify(
        params?.page || 1,
        params?.perSize || "",
        params?.search || {
          verificationStageStatus: "",
          projectIds: [],
          projectAttributeId: "",
          toTime: "",
          fromTime: "",
          stageName: "",
          driverId: "",
          smsSendingDateTimeFrom: "",
          smsSendingDateTimeTo: "",
          projectClassificationId: "",
          searchKey: "",
          isPrinted: "",
          isFirstStageVerified: "",
        },
      );
      return data;
    },
    enabled: !!params,
    ...reactQueryCacheAndRefetchOptions,
  });
};
